
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ScrollTracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ScrollTracking label='content50' mdxType="ScrollTracking" />
    <h4>«506 Bilder mit Kinderpornografie»</h4>
    <p>
  Ab Mitte April 2018 sucht William W. im Internet offenbar gezielt nach nach Kinderpornographie. Auf einer Festplatte
  wird die Polizei später «506 Bilder mit Kinderpornografie» finden. So steht es in der aktuellen Anklageschrift der
  Solothurner Staatsanwaltschaft, die dem Tamedia Recherchedesk vorliegt. Zudem hätten die Behörden 1689 Bilder
  sichergestellt, bei denen nicht abschliessend zu erkennen sei, ob die dargestellten Personen minderjährig sind.
    </p>
    <p>
  Mitte 2018 gerät William W. definitiv in eine persönliche Krise – was nichts Gutes verheisst für sein Rückfallrisiko.
  Das Restaurant, welches er eröffnen will, braucht neue Fenster und teure Abluftfilter, er erhält keine Baubewilligung,
  die Eröffnung verzögert sich. Für die Lebenskosten muss mittlerweile die christliche Gemeinschaft aufkommen. Er stehe
  «unter einem gewissen Druck», gibt er gegenüber der Bewährungshilfe an. Dann verliert er auch noch seine Wohnung,
  gekündigt, offenbar hatte sich ein Nachbar über Lärm beschwert.
    </p>
    <p>
  Das neue Gutachten liegt nun vor. Es kommt zu einem ähnlichen Fazit wie frühere Beurteilungen: William W. leide an
  einer pädophilen Störung. Mittel- und langfristig sei «von einem erhöhten Risiko für erneute sexuelle Übergriffe an
  Kindern auszugehen», stellt der beauftragte Psychiater laut Untersuchungsbericht fest.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;